module.exports = __webpack_public_path__ + "img/title.0da6f4a7.gif";